export const GEOJSON_FEATURE_COLOR = "rgba(255, 0, 255, 0.7)";
export const GEOJSON_FEATURE_STROKE_COLOR = "rgba(255, 0, 255, 1)";
export const GEOJSON_FEATURE_STROKE_WIDTH = 2;

export const GEOJSON_FEATURE_COLOR_ACTIVE = "rgba(255, 0, 255, 0.7)";
export const GEOJSON_FEATURE_STROKE_COLOR_ACTIVE = "#ffd9b3";
export const GEOJSON_FEATURE_COLOR_HOVER = "#e31212";
